"use client";

// Fehlerzustand des Mitgliederbereichs: ein Satz in der Sprache des
// Mitglieds, ein Knopf, der Weg zurueck. Die technische Meldung
// bleibt auf dem Server; die Kennung hilft dem Vorstand beim Melden.
import { useEffect } from "react";
import Link from "next/link";
import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function PortalFehler({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <EmptyState
      icon={TriangleAlert}
      title="Das ließ sich gerade nicht laden"
      description={
        error.digest
          ? `Bitte versuche es noch einmal. Bleibt es dabei, nenne dem Vorstand die Kennung ${error.digest}.`
          : "Bitte versuche es noch einmal — meist liegt es an einer wackligen Verbindung."
      }
      action={
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button onClick={reset}>Noch einmal</Button>
          <Link href="/mein-bereich" className="text-body-sm text-text-secondary hover:text-text-primary px-3 py-2">
            Zum Start
          </Link>
        </div>
      }
    />
  );
}
